<div class="modal-dialog modal-dialog-centered modal-md">
  <div class="modal-content">
    <div class="modal-header">
      <div class="row">
        <h5 i18n class="modal-title container">Novo Usuário</h5>
      </div>
      <button type="button" (click)="onClose()" class="btn btn-fade-secondary btn-icon-block" data-dismiss="modal"
        aria-label="Close">
        <i class="material-icons">close</i>
      </button>
    </div>
    <div class="modal-body">
      <form [formGroup]="userForm" (submit)=" onSubmit()" enctype="multipart/form-data">
        <div class="row">
          <div class="col-md-12">
            <app-input i18n-label type="text" formControlName="email" label="E-mail" inputRequired=true></app-input>
          </div>
          <div class="col-md-12">
            <div class="form-group has-error-select">
              <app-input type="select" [list]="companies" label="Empresa" formControlName="companyId" selectText="name"
                selectValue="id" placeholder="Selecione uma empresa" i18n-placeholder inputRequired=true i18n-label
                (ngModelChange)="userGroupsByCompany($event)">
              </app-input>
            </div>
          </div>
          <div class="col-md-12">
            <div class="form-group">
              <app-input type="multiselect" [list]="userGroupContracts" label="Grupos de Usuários"
                formControlName="groupIds" selectText="prettyName" selectValue="id" selectShowLimit="2"
                placeholder="Selecione grupo(s)" i18n-placeholder i18n-label>
              </app-input>
            </div>
          </div>
          <div class="col-md-12">
            <app-input i18n-label type="text" formControlName="role" label="Cargo"></app-input>
          </div>
          <div class="col-md-12">
            <app-input i18n i18n-label type="text" formControlName="cpf" format="ddd.ddd.ddd-dd" label="CPF">
            </app-input>
          </div>
          <div class="col-md-12">
            <app-input i18n-label type="text" formControlName="registryNumber" label="N° da Matrícula"
              max=5></app-input>
          </div>
        </div>
        <div class="row mb-3">
          <div class="col-md-12">
            <label class="form-control-label" i18n>Observações:</label>
            <textarea formControlName="extraData" rows="2" class="form-control"></textarea>
          </div>
        </div>

        <div class="row mb-3" *ngIf="currentUser && (currentUser.superUser || currentUser.adminManagerUser)">
          <div class="col-md-12">
            <mat-checkbox i18n formControlName="superUser" color="primary">
              Super Usuário
            </mat-checkbox>
            <i class="material-icons icon-sm text-secondary" style="padding-left: 4px;"
              appTooltip="Acesso total à plataforma, sem restrições de permissões.">help</i>
          </div>

          <ng-container *ngIf="featureFlagGestorAdmin">
            <div class="col-md-12">
              <mat-checkbox i18n formControlName="adminManagerUser" color="primary">
                Gestor Administrativo
              </mat-checkbox>
              <i class="material-icons icon-sm text-secondary" style="padding-left: 4px;"
                appTooltip="Permite gerenciar permissões de usuários administrativos.">help</i>
            </div>
            <div class="col-md-12">
              <mat-checkbox i18n formControlName="adminUser" color="primary">
                Usuário Administrativo
              </mat-checkbox>
              <i class="material-icons icon-sm text-secondary" style="padding-left: 4px;"
                appTooltip="Permite acesso à área administrativa da plataforma.">help</i>
            </div>
          </ng-container>
        </div>

        <div class="row mt-3">
          <div class="col-12">
            <label class="form-control-label" i18n>Arquivos:</label>
            <app-file-upload i18n-text="@@TextMultipleLabel" formControlName="files" [files]="documentFiles"
              (outputFiles)="documentFiles = $event"
              accept="image/jpg, image/jpeg, image/png, image/gif, video/mp4, video/mpeg, application/doc, application/docx, application/pdf"
              text="Você pode selecionar no máximo até 10 arquivos." limit="10"></app-file-upload>
          </div>
        </div>
      </form>
    </div>
    <div class="modal-footer">
      <button (click)="onCancel()" class="btn btn-outline-secondary">
        <app-loading [promise]="promise" text="Cancelar" i18n-text></app-loading>
      </button>
      <button (click)="onSubmit()" [ngClass]="{btn: true, 'btn-primary': true, disabled: !isValid}">
        <app-loading [promise]="promise" text="Confirmar" i18n-text></app-loading>
      </button>
    </div>
  </div>
</div>
